import React from 'react';

const Ruler = () => {
  return (
    <hr style={{color:"#DFDFDF",opacity:0.5,marginTop:10,marginBottom:10,width:"100%" }}/>
  )
};

export default Ruler;
